import { authedQuery, gql } from '@crystal-eyes/utils/apis/graphqlApi'

const GENERATE_SIGNED_PROFILE_PHOTO_URL_QUERY = gql`
  mutation GeneratePresignedUrl($key: String!) {
    generatePresignedUrl(key: $key)
  }
`

const GENERATE_SIGNED_LOGO_URL_QUERY = gql`
  mutation GeneratePresignedUrlForLogoUpload(
    $key: String!
    $orgId: String!
    $contentType: String!
  ) {
    createSignedUrlForLogoUpload(
      key: $key
      orgId: $orgId
      contentType: $contentType
    ) {
      url
      expiration
    }
  }
`

export const uploadFileToS3 = async (
  key: string,
  file: File,
): Promise<boolean> => {
  const urlResponse = await generateSignedProfilePhotoUrl(key)
  const signedUrl = urlResponse.generatePresignedUrl
  const response = await fetch(signedUrl, {
    method: 'PUT',
    headers: {
      'Content-Type': 'image/jpeg',
    },
    body: file,
  })
  return response.ok
}

export const uploadLogoFileToS3 = async (
  key: string,
  file: File,
  contentType: string,
  orgId: string,
): Promise<boolean> => {
  const urlResponse = await generateSignedLogoUrl(key, contentType, orgId)
  const signedUrl = urlResponse.createSignedUrlForLogoUpload.url
  const response = await fetch(signedUrl, {
    method: 'PUT',
    headers: {
      'Content-Type': contentType,
    },
    body: file,
  })
  return response.ok
}

const generateSignedProfilePhotoUrl = async (key: string) => {
  return authedQuery(GENERATE_SIGNED_PROFILE_PHOTO_URL_QUERY, {
    key: key,
  })
}

const generateSignedLogoUrl = async (
  key: string,
  contentType: string,
  orgId: string,
) => {
  return authedQuery(GENERATE_SIGNED_LOGO_URL_QUERY, {
    key: key,
    contentType: contentType,
    orgId: orgId,
  })
}
